export const state = {
  fee_type_level1: [],
  fee_type_level2: [],
  fee_type_level3: [],
  fee_type_level4: [],
};
